export const EASYCATION_INSPECTION_REQUEST_URL = 'https://www.easycation.co.kr';

// 2026-06-18 12:00 KST
export const EASYCATION_INSPECTION_MENU_VISIBLE_AT = Date.parse('2026-06-18T03:00:00.000Z');

export function isEasycationInspectionMenuVisible(now = Date.now()) {
  return now >= EASYCATION_INSPECTION_MENU_VISIBLE_AT;
}

export function scheduleEasycationInspectionMenuVisibility(onVisible) {
  if (isEasycationInspectionMenuVisible()) {
    onVisible(true);
    return () => {};
  }

  let timer = null;
  const maxDelay = 2147483647;
  const queue = () => {
    const delay = EASYCATION_INSPECTION_MENU_VISIBLE_AT - Date.now();

    if (delay <= 0) {
      onVisible(true);
      return;
    }

    timer = window.setTimeout(queue, Math.min(delay, maxDelay));
  };

  queue();

  return () => {
    if (timer) {
      window.clearTimeout(timer);
    }
  };
}
